
class TrendTerm extends HTMLElement {
  constructor() {
    super();
    this.trendEv = new Event('trend', {bubbles: true});
    
    this.addEventListener('click', () => {
      this.dispatchEvent(this.trendEv);
    });
  }

}

customElements.define('trend-term', TrendTerm);

class SearchDrawer extends HTMLElement {
  constructor() {
    super();

    this.term = '';
    this.nextUrl = null;
    this.form = this.querySelector('form');
    this.input = this.form.querySelector('form input[name="search"]');
    this.resultContainer = this.querySelector('.search-container');
    this.closer = this.querySelector('.search_header img');

    this.debounceSearch = debounce(() => {
      this.search();
    }, 500);

    this.addAction();

  }

  addAction() {
    this.addEventListener('trend', this.onTrend.bind(this));
    this.addEventListener('scroll', this.onLoadMore);
    this.closer.addEventListener('click',() => {
      this.close();
    });
    this.form.addEventListener('submit', (ev) => {
      ev.preventDefault();
      let term = this.input.value;
      this.onSubmit(term);
    });
    this.input.addEventListener('keyup', (ev) => {
      if(ev.key != 'Delete' && ev.key != 'Backspace') {
        console.log(ev);
        this.onSubmit(ev.target.value);
      }
      if (ev.target.value == '') {
        this.dataset.status = '';
      }
    })
  }

  onSubmit(term) {
    if(term) {
      this.term = term;
      this.nextUrl = `/search?q=${this.term}&type=product&sections=search-result`;
      console.log(term);
      this.debounceSearch();
    } else {
      this.dataset.status = '';
    }
  }

  onTrend(ev) {
    let term = ev.target.dataset['term'];
    this.term = term;
    this.nextUrl = `/search?q=${this.term}&sections=search-result`;
    this.search();
  }

  onLoadMore() {
    const scrollableLength = this.scrollHeight;
    const remainingScroll = scrollableLength - this.scrollTop - this.clientHeight;

    remainingScroll == 0 && this.nextUrl ? this.debounceSearch() : null;
  }

  search() {
    let obj = this;
    console.log(obj.nextUrl);
    show_search_drawer_loading()
    fetch(obj.nextUrl)
    .then(res => res.json())
    .then(res => {
      let html = res['search-result'];
      const domResult = new DOMParser().parseFromString(html, 'text/html');

      obj.input.value = obj.term;
      obj.dataset['status'] = 'search';

      if(!obj.nextUrl.includes('?page=')) {
        obj.resultContainer.innerHTML = '';
      } 

      let count = parseInt(domResult.querySelector('.search-count').innerHTML);
      console.log(count);

      if(count > 0) {
        obj.querySelector('.search-results span.count').innerHTML = `${count > 1 ? count + ' results': count + ' result'}`;

        domResult.querySelectorAll('.search-product').forEach(child => {
          obj.resultContainer.appendChild(child);
        });
        
        const next = domResult.querySelector('.load_more');
        next.dataset.nextEnable ? obj.nextUrl = `${next.dataset.next}&sections=search-result` : obj.nextUrl = null;

        console.log(obj.nextUrl);
      } else {
        obj.querySelector('.no-result strong').innerHTML = obj.term;
        obj.querySelector('.search-results span.count').innerHTML = '0 results';
        obj.dataset['status'] = 'no-result';
      }
    })
    .catch(err => console.log(err))
    .finally(hide_search_drawer_loading);
  }

  open() {
    show_overlay();
    document.querySelector('body').classList.add('search-open');
    let top = 0;
    this.style.top = `${top}px`;
    this.style.height = `calc(100% - ${top}px)`;
    if(window.innerWidth <= 1000) {
      const header = document.querySelector('#shopify-section-header');
      top = header.getBoundingClientRect().bottom;
      this.style.top = `${top}px`;
      this.style.height = `calc(100% - ${top}px)`;
    }
    this.classList.add('open');
  }

  close() {
    hide_overlay();
    document.querySelector('body').classList.remove('search-open');
    this.classList.remove('open');
  }
}

customElements.define('search-drawer', SearchDrawer);
window.searchElement = document.querySelector('search-drawer');

function debounce(fn, timeout=600) {
  let timer;
  return (...args) => {
    clearTimeout(timer);
    timer = setTimeout(() => {
      fn.apply(this, args);
    }, timeout);
  }
}

document.querySelector('.mob_search').addEventListener('click', () => {
  mobile_menu_open(false);
  window.searchElement.open();
}); 
document.querySelector('.des_search').addEventListener('click', () => {
  window.searchElement.open();
}); 

function show_search_drawer_loading() {
  $('.search_loading_overlay').css('display', 'flex');
}

function hide_search_drawer_loading() {
  $('.search_loading_overlay').hide();
}